// @flow
import type { AxiosPromise, AxiosInstance } from "axios";

const getDriveUpListings = (
  id: string
): ((apiInstance: AxiosInstance) => AxiosPromise<>) => (apiInstance) => {
  return apiInstance.get(`/v4/listings/driveup`, {
    params: {
      "filter[id]": id
    }
  });
};

export default getDriveUpListings;
